module.exports = __webpack_public_path__ + "static/eyedoctor-be4f6885f98b0a4590cc10845ea3210f.jpg";